import React from 'react'

interface HeaderProps {
  username?: string;
  onLogout: () => void;
}

const styles = {
  header: {
    width: '100%',
    height: '64px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    padding: '0 24px',
    position: 'fixed' as const,
    top: 0,
    right: 0,
    zIndex: 98,
    marginLeft: '240px'
  },
  headerContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '100%',
    margin: '0 auto'
  },
  userInfo: {
    fontSize: '16px',
    color: '#333',
    fontWeight: 500
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center'
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    border: 'none',
    backgroundColor: '#dc3545',
    color: 'white',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  logoutIcon: {
    fontSize: '18px'
  }
};

const Header: React.FC<HeaderProps> = ({ username, onLogout }) => {
  return (
    <header style={styles.header}>
      <div style={styles.headerContent}>
        <div style={styles.userInfo}>
          Welcome, {username || 'Affiliate'}
        </div>
        <div style={styles.headerActions}>
          <button 
            style={styles.logoutBtn}
            onClick={onLogout}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#c82333';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#dc3545';
            }}
          >
            <i className='bx bx-log-out' style={styles.logoutIcon}></i>
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header